export { default } from './Proportion';
export type { ProportionProps } from './Proportion.types';
